import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

interface TemplateDataI {
  policyTerms?: string;
  intermediaryName?: string;
  years?: number;
  intermediaryFee?: string;
  intermediaryFeePeriod?: string;
  intermediarySubscriptionFee?: string;
  intermediarySubscriptionFeePeriod?: string;
}

export type StringTemplates = 'policy_terms'
  | 'name_intermediary'
  | 'years'
  | 'intermediary_fee'
  | 'intermediary_subscription_fee_period'
  | 'intermediary_subscription_fee'
  | 'intermediary_fee_period';

@Injectable()
export class TemplateService {
   constructor(private translateService: TranslateService) {
   }

  parseTemplatedStatement(
    statement: string,
    template: StringTemplates | Array<StringTemplates>,
    data: TemplateDataI
  ): string {
    let parsedStatement = statement ? this.translateService.instant(statement) : '';
    let templateForParse = [];
    if (template instanceof Array) {
      templateForParse = template;
    } else {
      templateForParse.push(template);
    }

    templateForParse.forEach(item => {
      switch (item) {
        case 'policy_terms':
          parsedStatement = parsedStatement.replace('[POLICY_TERMS]', data.policyTerms || '');
          break;

        case 'name_intermediary':
          parsedStatement = parsedStatement.replace('[NAME_INTERMEDIARY]', data.intermediaryName || this.translateService.instant('Common.DefaultIntermediaryName'));
          break;

        case 'years':
          parsedStatement = parsedStatement.replace('[YEARS]', data.years || '');
          break;

        case 'intermediary_fee':
          parsedStatement = parsedStatement.replace('[INTERMEDIARY_FEE]', data.intermediaryFee || '');
          break;
        case 'intermediary_fee_period':
          parsedStatement = data.intermediaryFeePeriod ?  this.translateService.instant(
            `IntermediaryFeePeriodEnum.${data.intermediaryFeePeriod}`) : '';
          break;
        case 'intermediary_subscription_fee_period':
          parsedStatement = data.intermediarySubscriptionFeePeriod ?  this.translateService.instant(
            `IntermediaryFeePeriodEnum.${data.intermediarySubscriptionFeePeriod}`) : '';
          break;
        case 'intermediary_subscription_fee':
          parsedStatement = parsedStatement.replace('[SUBSCRIPTION_FEE]', data.intermediarySubscriptionFee || '');
          break;
      }
    });

    return parsedStatement;
  }
}
